import { useId } from 'react'
import { Icon } from './Icon'
import styles from './CodeInput.module.css'

interface CodeInputProps {
  label?: string
  value: string
  onChange: (value: string) => void
  length?: number
  placeholder?: string
  hint?: string
  error?: string
  autoFocus?: boolean
}

/** Pickup / check-in code: auto-uppercase, fixed length, Outfit 26/600 with wide tracking. */
export function CodeInput({
  label = 'Código do morador',
  value,
  onChange,
  length = 6,
  placeholder = '4K7QP2',
  hint,
  error,
  autoFocus,
}: CodeInputProps) {
  const id = useId()
  return (
    <div className={styles.wrap}>
      <label htmlFor={id} className={styles.label}>
        {label}
      </label>
      <input
        id={id}
        className={styles.input}
        value={value}
        maxLength={length}
        placeholder={placeholder}
        autoFocus={autoFocus}
        data-autofocus={autoFocus ? '' : undefined}
        autoComplete="off"
        autoCapitalize="characters"
        spellCheck={false}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
        onChange={(e) => onChange(e.target.value.toUpperCase().slice(0, length))}
      />
      {error ? (
        <span id={`${id}-error`} className={styles.error}>
          <Icon name="error" size={16} />
          {error}
        </span>
      ) : (
        hint && (
          <span id={`${id}-hint`} className={styles.hint}>
            {hint}
          </span>
        )
      )}
    </div>
  )
}
